module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-900.059ad0cc.eot";